import React, { Component} from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import actions from 'actions';
import SponsorList from 'components/Admin/Sponsor/List'
import { push } from 'redux-router';
import Toolbar from 'components/Admin/Sponsor/Toolbar';

const {
  loadAdminSponsorsSaga,
  showDeleteSponsorsConfirmationModal
} = actions;

class Sponsors extends Component {
  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    dispatch: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      sponsor_ids: [],
      page: props.page || 1,
      query: {
        title: '',
        order: {
          created_at: 'desc'
        },
        ...props.query
      }
    }
  }

  componentWillMount = () => {
    this.loadSponsors();
  }

  deleteSponsors = () => {
    if(this.state.sponsor_ids.length > 0)
      this.props.deleteSponsors(this.state.sponsor_ids)
  }

  onChangePage = (page = 1) => {
    this.setState({
      page
    }, this.loadSponsors);
  }

  checkedSponsorIds = (sponsor_id) => {
    var ids = _.assign(this.state.sponsor_ids),
        index = this.state.sponsor_ids.indexOf(sponsor_id);

    if(index == -1) {
      ids.push(sponsor_id)
    } else {
      ids.splice(index, 1)
    }
    this.setState({ sponsor_ids: ids })
  }

  loadSponsors = () => this.props.loadSponsors(this.state.page, this.state.query)

  changeQuery = (query, timeout = 500) => {
    this.setState({ query }, () => {
      if(this.timer){
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(this.loadSponsors, timeout)
    })
  }

  onOrderChange = (field = 'created_at', order = 'desc') => {
    const query = {
      ...this.state.query,
      order: {
        [field]: order
      }
    }
    this.changeQuery(query, 0);
  }

  onChangeQuery = (field, value) => {
    const query = {...this.state.query, ...{ [field]: value }};
    this.setState({ page: 1 }, () => {
      this.changeQuery(query)
    });
  }

  render() {
    const {
      deleteSponsors,
      state,
      onChangeQuery,
      onDateRangeChange
    } = this;
    return (
      <main className="site--width clearfix container_statistics">
        <div className="container_admin_sponsor">
        </div>
        <Toolbar
          filterProps={{
            ...state,
            onDateRangeChange,
            onChangeQuery
          }}
          toolsProps={{
            count: this.props.count,
            deleteSponsors
          }}
        />
        <div className="admin_sponsors_table admin_table">
          <SponsorList
            sponsors={this.props.sponsors}
            navigateToSponsor={this.props.navigateToSponsor}
            checkedSponsorIds={this.checkedSponsorIds}
            sponsor_ids={this.state.sponsor_ids}
            onOrderChange={this.onOrderChange}
            query={this.state.query}
            paginationProps={{
              onChangePage: this.onChangePage,
              page: this.state.page,
              total_pages: this.props.total_pages
            }}
          />
        </div>
      </main>
    );
  }
}

function mapStateToProps(state) {
  return {
    sponsors: state.sponsors.admin.list.values,
    count: state.sponsors.admin.list.count,
    total_pages: state.sponsors.admin.list.total_pages,
    page: state.sponsors.admin.list.page,
    query: state.sponsors.admin.list.query
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch: dispatch,
    navigateToSponsor: (id) => dispatch(push(`/sponsors/${id}`)),
    deleteSponsors: (sponsor_ids) => dispatch(showDeleteSponsorsConfirmationModal(sponsor_ids)),
    loadSponsors: (page, query) => dispatch(loadAdminSponsorsSaga(page, query))
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Sponsors);



// WEBPACK FOOTER //
// ./src/containers/Admin/Sponsor/Sponsors.jsx